import PropTypes from 'prop-types';
import BookMaterialComponent from 'components/BookMaterialComponent';

function SchoolBookMaterialComponent({ summaryItems }) {
  const materials = [];

  if (summaryItems.courses !== undefined && summaryItems.courses.length > 0) {
    summaryItems.courses.forEach((c) => {
      materials.push(c.bookMaterial);
    });
  } else {
    materials.push(summaryItems.bookMaterial);
  }

  return materials.map(
    (bm) =>
      !!bm &&
      bm.id > 0 && (
        <BookMaterialComponent
          key={bm.id}
          bookMaterialPriceExchanged={bm.exchanged}
          bookMaterialNote={summaryItems?.bookNote}
          bookMaterialChargedBefore={summaryItems?.bookChargedBefore}
        />
      )
  );
}

export default SchoolBookMaterialComponent;

SchoolBookMaterialComponent.propTypes = {
  summaryItems: PropTypes.instanceOf(Object).isRequired,
};
